import classnames from "classnames";
import { useEffect, useState } from "react";
import { Col, Form, Input, Label, Row } from "reactstrap";
import { CloseIcon } from "../../../constants/icons";
import { Button, TextField, TextGroup, TextLabel } from "../../Styled";
import "./packageLeadTypeStyle.css";

const AddPackageLeadTypeForm = (props) => {
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setErrors(props.errors);
  }, [props]);

  return (
    <div className="modalContent">
      <div className="modalHeader">
        <h4 className="modalTitle">Add Package Lead Type</h4>
        <p>All fields are required</p>
        <span className="closeIcon" onClick={() => props.close(false)}>
          <CloseIcon />
        </span>
      </div>
      <Form className="w-100 white-form" onSubmit={props.submit}>
        <TextGroup className={classnames({ error: errors.package_name })}>
          <TextLabel>
            Package Name{" "}
            {Object.keys(props?.requiredField || {})?.includes("package_name")
              ? " *"
              : ""}
          </TextLabel>
          <TextField
            type="text"
            name="package_name"
            placeholder="e.g. QFN, SOIC"
            value={props.fillData.package_name || ""}
            onChange={props.change}
          />
          {errors.package_name ? (
            <span className="error-text">{errors.package_name}</span>
          ) : null}
        </TextGroup>
        <TextGroup className={classnames({ error: errors.classification })}>
          <TextLabel>Classification *</TextLabel>
          <Row>
            <Col>
              <Label className="customRadio d-inline-block">
                <Input
                  type="radio"
                  name="classification"
                  value="lead"
                  checked={props.fillData.classification === "lead"}
                  onChange={props.change}
                />
                <span className="span-text">Lead</span>
              </Label>
              <Label className="customRadio d-inline-block">
                <Input
                  type="radio"
                  name="classification"
                  value="leadless"
                  checked={props.fillData.classification === "leadless"}
                  onChange={props.change}
                />
                <span className="span-text">Leadless</span>
              </Label>
              <Label className="customRadio d-inline-block">
                <Input
                  type="radio"
                  name="classification"
                  value="unknown"
                  checked={props.fillData.classification === "unknown"}
                  onChange={props.change}
                />
                <span className="span-text">Unknown</span>
              </Label>
            </Col>
          </Row>
          {errors.classification ? (
            <span className="error-text">{errors.classification}</span>
          ) : null}
        </TextGroup>
        <TextGroup>
          <Button className="importBtn blue px-5 w-auto" type="submit">
            Save
          </Button>
        </TextGroup>
      </Form>
    </div>
  );
};

export default AddPackageLeadTypeForm;
